module.exports = __webpack_public_path__ + "img/weddings_13_V.31e4a09b.webp";